import React, { useContext } from 'react'
import styled from 'styled-components'
import theme from '../../../common/theme'
import Icon from '../../../common/Icon'
import PageLayout from '../../components/PageLayout'
import { SimulationContext } from './SimulationPage'

const SimulationFailedContainer = styled(PageLayout)`
  color: ${ theme.palette.black };
  padding: 0 20px;
  align-items: center;
  .content{
    > a {
      text-decoration: underline;
    }
   svg {
      fill: ${ theme.palette.red };
      margin-right: 20px;
    }
    .title{
      font-size: 20px;
      font-weight: bold;
      display: flex;
      align-items: center;
      margin: 20px 0;
    }
  }
`

function SimulationFailed({ ...props }) {
  const { parentHistory } = useContext(SimulationContext)

  const onSubmit = () => {
      parentHistory.push('/')
  }
  const actions = {
    submitTxt: 'Retour à la page d’accueil',
    onSubmit: onSubmit
  }
  return (
    <SimulationFailedContainer
      actions={ actions }
    >
      <Icon name="close"/>
      <div className="title">
        Vous n’êtes pas éligible à l’allocation frais de garde d’enfant(s)
      </div>
      Pour en savoir plus sur les plafonds permettant de bénéficier de l’allocation, veuillez cliquer sur le lien suivant :
      <a onClick={() => parentHistory.push('/faq')}>J’ai une question ?</a>
    </SimulationFailedContainer>
  )
}

export default SimulationFailed
